<template>
  <div>
    <!-- <div class="background-board">
      <div class="row">
        <div v-for="i in 1" :key="i" class="hole"></div>
      </div>
    </div> -->
    <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png" @click="openPopup('first')" >
    <button @click="openPopup()">Test</button>

    <DocStatusUpdate title="First popup" :docStatusList.sync="docStatuses" :docTypeList.sync="docTypes" :statusList.sync="statusList"
      :showPopup.sync="firstPopup" />
    <DocStatusUpdate title="Second popup" :docStatusList.sync="docStatuses" :docTypeList.sync="docTypes" :statusList.sync="statusList"
      :showPopup.sync="secondPopup" />
  </div>
</template>

<script>
/* eslint-disable */
import DocStatusUpdate from '@/components/DocStatusUpdate.vue';

export default {
  components: {
    DocStatusUpdate
  },
  data: function() {
    return {
      docTypes: [],
      docStatuses: [],
      statusList: [],

      firstPopup: false,
      secondPopup: false
    }
  },
  props: {
  },
  methods: {
    openPopup: function(item) {
      if (item == 'first') {
        this.firstPopup = true;
      } else {
        this.secondPopup = true;
      }
    }
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.background-board {
  background-color: red;
  width: 100%;
  max-width: 400px;

  > .row {
    display: flex;
    > .hole {
      height: 50px;
      width: 50px;
      border-radius: 100%;
      box-shadow: 0 0 0 50px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>